"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBoolean = void 0;
const toBoolean = (value) => {
    if (value === undefined || value === null)
        return false;
    if (typeof value === 'number')
        return value !== 0;
    if (typeof value === 'boolean')
        return value;
    if (typeof value === 'string')
        return value === 'true';
    return false;
};
exports.toBoolean = toBoolean;
//# sourceMappingURL=boolean.js.map